import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues = {
  eventCode: '',
  destinationCode: '',
  subscriberCode: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageEventRegistrationInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageEventRegistrationInitializer.displayName = 'Page event-registration initializer component';

export default PageEventRegistrationInitializer;
